export default "__VITE_PUBLIC_ASSET__bfe222b5__"